export default "__VITE_ASSET__BMXZvaJq__"